<script>
export default {
	props: {
		label: {
			type: String,
			default: '',
		},
		inputIdentifier: {
			type: String,
			default: '',
		},
		val: {
			type: [String, Number],
			default: '',
		},
		inputType: {
			type: String,
			default: 'text',
		},
	},
};
</script>

<template>
	<div>
		<label
			class="block mb-2 text-sm font-medium text-gray-700 dark:text-gray-300"
			:for="label"
			>{{ label }}</label
		>
		<input
			class="w-full px-4 py-2 border border-gray-300 dark:border-gray-700 text-gray-900 dark:text-gray-100 bg-white dark:bg-black rounded-md shadow-sm focus:ring-1 focus:ring-gray-500 focus:border-gray-500 transition-colors sm:text-sm"
			:id="inputIdentifier"
			:name="inputIdentifier"
			:placeholder="label"
			:aria-label="inputIdentifier"
			:value="val"
			:type="inputType"
			v-bind="$attrs"
			@input="$emit('update:val', $event.target.value)"
			required
		/>
	</div>
</template>

<style lang="scss" scoped></style>
